module.exports = __webpack_public_path__ + "img/image6.364b01f1.jpg";